import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { ReduxState } from "../../../../redux";
import { Button, Col, Row, Form, Modal, Alert } from "react-bootstrap";
import CategoriesPieChart from "./PieChart";
import { TagRegexes } from "./TagRegexes";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  addNewCategoryGroup,
  fetchPieChart,
  fetchTagRegexes,
} from "../../../../redux/reducers/TagRegexes";
import { categorizeAction } from "../../../../redux/reducers/Categories";
import { AnalyzeTransactionsTable } from "../AnalyzeTransactionsTable";
import AgTable from "../AnalyzeTransactionsTable/AgTable";
import { useHistory } from "react-router-dom";
import ClipLoader from "react-spinners/ClipLoader";
import { categorizeActionAsync } from "../../../../redux/reducers/CategoriesAsync";
import { useIsAdmin } from "../../../../utils/auth";
// import SupersetDash from "./SupersetPieChart.tsx.disabled";
import { DownloadModal } from "../../DataArchive/TransactionManager/DownloadModal";
import { TagCategoryRule } from "src/docuclipper/DocuclipperTypes";
import CategorizationTour from "../../DataArchive/TransactionManager/CategorizationTour";
import AllAccountsSelector from "../AnalyzeTransactionsTable/AllAccountsSelector";

export const Categorize: React.FC = () => {
  const [groupName, setGroupName] = useState("");
  const [dashboardReloadTrigger, setDashboardReloadTrigger] = useState(true);

  const dispatch = useDispatch();

  const {
    selectedTagRegexesSet,
    tagRegexesSets,
    loading: tagRegexesSetsLoading,
  } = useSelector((state: ReduxState) => state.TagRegexes);

  const { job } = useSelector((state: ReduxState) => state.JobData);
  const { categories, byCategoryKeyword } = useSelector(
    (state: ReduxState) => state.Categories
  );

  const { loading } = useSelector((state: ReduxState) => state.AsyncCategories);
  const { pieLoading } = useSelector((state: ReduxState) => state.TagRegexes);
  const { selectedAccountReconciler } = useSelector(
    (state: ReduxState) => state.Reconciler
  );

  const jobId = job ? job.id : "";

  const history = useHistory();
  const { selectedL1: l1, selectedL2: l2 } = useSelector(
    (state: ReduxState) => state.TagLevel
  );
  React.useEffect(() => {
    dispatch(fetchTagRegexes("categorize"));
  }, []);
  React.useEffect(() => {
    if (selectedAccountReconciler) {
      dispatch(
        fetchPieChart({ selectedAccount: selectedAccountReconciler, l1, l2 })
      );
    }
  }, [selectedAccountReconciler]);

  React.useEffect(() => {
    if (selectedTagRegexesSet && categories.length === 0) {
      dispatch(categorizeAction());
    }
  }, []);

  const { isAdmin } = useIsAdmin();

  const [showNewGroup, setShowNewGroup] = useState(false);
  const toggleAddNewCategoryGroup = () => setShowNewGroup(!showNewGroup);

  // Applied to the transactions table when clicking Category Breakdown or Vendor Breakdown rows
  const [categoryFilterFromBreakdown, setCategoryFilterFromBreakdown] =
    useState<string | undefined>(undefined);
  const [categoryKeywordFilterFromBreakdown, setCategoryKeywordFilterFromBreakdown] =
    useState<string | undefined>(undefined);

  const [rowData, setRowData] = useState<{ name; value; color }[]>([]);
  React.useEffect(() => {
    setRowData(categories);
  }, [JSON.stringify(categories)]);

  const [columnDefs] = useState([
    {
      headerName: "Category",
      field: "name",
      filter: "agTextColumnFilter",
      flex: 2,
    },
    {
      headerName: "Amount $",
      field: "value",
      filter: "agNumberColumnFilter",
      flex: 1,
      sortable: true,
      sort: "desc" as const,
    },
  ]);

  const lsKey = "docuclipper.ui.selectedCategoryGroup";

  const handleAddNewCategoryGroup = () => {
    const rule: TagCategoryRule = {
      keywords: [],
      negativeKeywords: [],
      tag: groupName.trim(),
    };
    dispatch(addNewCategoryGroup(groupName, rule));
    localStorage.setItem(lsKey, groupName);
    toggleAddNewCategoryGroup();
  };

  useEffect(() => {
    setDashboardReloadTrigger(!loading);
  }, [loading]);

  useEffect(() => {
    if (showNewGroup) {
      setGroupName("");
    }
  }, [showNewGroup]);

  // console.log({ categories, byCategoryKeyword });
  return (
    <div className="m-2">
      <Row className="justify-content-end m-2 align-items-center">
        <CategorizationTour />
        <a
          href="https://www.youtube.com/watch?v=alrd8zCClOw&authuser=0"
          target="_blnk"
          rel="noopener noreferrer"
        >
          <div className="mx-2 div--help-video">
            <FontAwesomeIcon icon="play" />
            <span className="ml-2">Watch Categorization Demo</span>
          </div>
        </a>
        {/* <Button
          className="categorization-tour-add-group"
          variant="link"
          onClick={toggleAddNewCategoryGroup}
        >
          <FontAwesomeIcon icon="plus" />
          <span className="ml-1" data-cy="add-new-category-group-link">
            Add New Category Group
          </span>
        </Button>
         */}
        <Modal show={showNewGroup} onHide={toggleAddNewCategoryGroup}>
          {/* @ts-ignore - React Bootstrap type compatibility issue */}
          <Modal.Header closeButton>
            <Modal.Title>Add New Category Group</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Row>
              <Col>
                <Form.Group>
                  <Form.Label>Category Group Name</Form.Label>
                  <Form.Control
                    name="groupName"
                    value={groupName}
                    onChange={(e) => {
                      setGroupName(e.target.value);
                    }}
                    type="text"
                  />
                </Form.Group>
              </Col>
            </Row>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={toggleAddNewCategoryGroup}>
              Close
            </Button>
            <Button
              variant="primary"
              onClick={handleAddNewCategoryGroup}
              className=""
            >
              <FontAwesomeIcon icon="plus" />
              <span
                className="ml-1"
                data-cy="add-new-category-group-modal-button"
              >
                Add New Category Group
              </span>
            </Button>
          </Modal.Footer>
        </Modal>
      </Row>

      {tagRegexesSets.length === 0 && !tagRegexesSetsLoading && (
        <Alert variant="danger">
          You don't have any category groups. Click on "Add New Category Group"
          to create one.
        </Alert>
      )}
      {tagRegexesSets.length > 0 && (
        <>
          <Row className="align-items-center">
            <Col md="6">
              <TagRegexes />
            </Col>
            <Col md="6">
              <div className="d-flex align-items-center justify-content-end flex-wrap gap-2">
                <AllAccountsSelector
                  onAccountChange={(newAccount) => {
                    dispatch(
                      fetchPieChart({
                        selectedAccount: newAccount,
                        l1,
                        l2,
                      })
                    );
                  }}
                />

                {!loading && (
                  <Button
                    className="categorization-tour-categorize mx-2"
                    variant="primary"
                    onClick={() => {
                      if (selectedTagRegexesSet) {
                        dispatch(categorizeActionAsync({ l1, l2 }));
                      }
                    }}
                  >
                    {`Categorize ${
                      selectedAccountReconciler === "__ALL__"
                        ? " All Accounts"
                        : `${selectedAccountReconciler} Account`
                    }`}
                  </Button>
                )}
                {loading && <ClipLoader />}

                <DownloadModal jobType={"bank"} btnVariant={"primary"} />
              </div>
            </Col>
          </Row>

          {/* Uncategorized Transactions Warning - Moved to top for visibility */}
          {categories.length > 0 &&
            (() => {
              const uncategorizedData = categories.find(
                (cat) => cat.name === "Uncategorized"
              );
              const hasUncategorized =
                uncategorizedData && uncategorizedData.value !== 0;

              return hasUncategorized ? (
                <Row className="mt-3 mb-3">
                  <Col md="12">
                    <Alert
                      variant="warning"
                      className="d-flex align-items-center"
                    >
                      <FontAwesomeIcon
                        icon="exclamation-triangle"
                        className="mr-2"
                      />
                      <div>
                        <strong>Uncategorized Transactions Detected</strong>
                        <span className="ml-2">
                          You have uncategorized transactions with a total value
                          of $
                          {Math.abs(uncategorizedData?.value || 0).toFixed(2)}.
                          Review them in the transactions table below.
                        </span>
                      </div>
                    </Alert>
                  </Col>
                </Row>
              ) : null;
            })()}

          {/* {false && (
            <div>
              <SupersetDash
                dashboardName={"categorizePieChart"}
                height={"400px"}
                width={"100%"}
                reload={dashboardReloadTrigger}
              />
            </div>
          )} */}
          {loading ? (
            <Row className="mt-4">
              <Col className="text-center">
                <ClipLoader size={50} />
                <div className="mt-3">
                  <h4>Categorization in progress...</h4>
                </div>
              </Col>
            </Row>
          ) : (
            categories.length > 0 && (
              <Row>
                <Col md={6}>
                  <Row>
                    <Col className="mt-4">
                      <h3>Category Breakdown</h3>
                      {categories.length > 0 && (
                        <AgTable
                          className="categorization-tour-summary"
                          data-cy="categorization-table"
                          hasExport={true}
                          rowData={rowData}
                          columnDefs={columnDefs}
                          width={"100%"}
                          height={200}
                          rowHeight={28}
                          headerHeight={32}
                          onRowClicked={(e) => {
                            const name = e.data?.name;
                            if (name != null) {
                              setCategoryFilterFromBreakdown(name);
                              setCategoryKeywordFilterFromBreakdown(undefined);
                            }
                          }}
                          getRowStyle={() => ({ cursor: "pointer" })}
                        />
                      )}
                    </Col>
                    <Col style={{ height: "300px" }}>
                      {!pieLoading && <CategoriesPieChart data={categories} />}
                      {pieLoading && <ClipLoader />}
                    </Col>
                  </Row>
                </Col>

                <Col md={6}>
                  <Row>
                    <Col className="mt-4">
                      <h3>Vendor Breakdown</h3>
                      <AgTable
                        hasExport={true}
                        rowData={byCategoryKeyword}
                        columnDefs={[
                          {
                            headerName: "Keyword",
                            field: "name",
                            flex: 2,
                          },
                          {
                            headerName: "Amount $",
                            field: "value",
                            flex: 1,
                            sortable: true,
                            sort: "desc",
                          },
                        ]}
                        width={"100%"}
                        height={200}
                        rowHeight={28}
                        headerHeight={32}
                        onRowClicked={(e) => {
                          const name = e.data?.name;
                          if (name != null) {
                            setCategoryKeywordFilterFromBreakdown(name);
                            setCategoryFilterFromBreakdown(undefined);
                          }
                        }}
                        getRowStyle={() => ({ cursor: "pointer" })}
                      />
                    </Col>
                    <Col style={{ height: "300px" }}>
                      {!pieLoading && (
                        <CategoriesPieChart data={byCategoryKeyword} />
                      )}
                      {pieLoading && <ClipLoader />}
                    </Col>
                  </Row>
                </Col>
              </Row>
            )
          )}
        </>
      )}

      <div className="m-2">
        {loading && (
          <Alert variant="info" className="mb-3">
            <ClipLoader size={20} className="mr-2" />
            Categorization in progress... The table will update automatically when complete.
          </Alert>
        )}
        <AnalyzeTransactionsTable
          setDashboardReloadTrigger={setDashboardReloadTrigger}
          categoryFilterFromBreakdown={categoryFilterFromBreakdown}
          categoryKeywordFilterFromBreakdown={categoryKeywordFilterFromBreakdown}
          onClearCategoryBreakdownFilter={() =>
            setCategoryFilterFromBreakdown(undefined)
          }
        />
      </div>
    </div>
  );
};
export default Categorize;
